export const sortGroupsByLastMessageTime = (groups) => {
  return [...groups].sort((a, b) => {
    const aTime = new Date(
      a.lastMessageRawTime || a.lastMessageTime || a.createdAt || 0
    ).getTime();
    const bTime = new Date(
      b.lastMessageRawTime || b.lastMessageTime || b.createdAt || 0
    ).getTime();
    // console.log(aTime, bTime, bTime - aTime, a, b);
    return bTime - aTime;
  });
};

export const formatParticipantName = (participant) => {
  if (!participant) return '';
  if (participant.name) return participant.name;
  const firstName = participant.first_name || '';
  const lastName = participant.last_name || '';
  return `${firstName} ${lastName}`.trim() || 'Unknown';
};

export const transformGroupFromApi = (apiGroup) => {
  return {
    id: apiGroup.group_id || apiGroup.id,
    name: apiGroup.subject || apiGroup.name,
    description: apiGroup.description || '',
    avatar: apiGroup.avatar || null,
    lastMessage: apiGroup.last_message || '',
    lastMessageTime: formatMessageTime(apiGroup.last_message_time),
    lastMessageRawTime: apiGroup.last_message_time,
    unreadCount: apiGroup.unread_count || 0,
    emailRecipients: apiGroup.emailRecipients || [],
    emailOnEachMessage: apiGroup.emailOnEachMessage || false,
    cswOpen: apiGroup.csw_open || false,
    members: [],
    messages: [],
    createdAt: apiGroup.createdAt,
  };
};

export const transformParticipantFromApi = (participant) => {
  return {
    id: participant.id || Date.now() + Math.random(),
    name: formatParticipantName(participant),
    phone: participant.phone_number || participant.phone,
    isAdmin: participant.is_admin || false,
    firstName: participant.first_name || '',
    lastName: participant.last_name || '',
    invitee: participant.invitee || false, // true if the participant was invited but not yet accepted
  };
};

export const transformParticipantToApi = (participant) => {
  if (typeof participant === 'string') {
    return participant;
  }

  const nameParts = (participant.name || '').split(' ');
  return {
    first_name: participant.firstName || nameParts[0] || '',
    last_name: participant.lastName || nameParts.slice(1).join(' ') || '',
    phone_number: participant.phone || participant.phone_number,
  };
};

export const transformMessageFromApi = (apiMessage) => {
  // Process message content - if this is an email response then clean up the content
  const emailResponsePrefix = 'In response to your message, the following reply has been received:';  
  let content = apiMessage.content || apiMessage.message || '';
  const displayed_content = apiMessage.displayed_content ?? apiMessage.displayedContent;
  if (content.startsWith(emailResponsePrefix)) {
    content = content.substring(emailResponsePrefix.length).trim();
  }

  return {
    id: apiMessage._id || apiMessage.id,
    sender: apiMessage.author || apiMessage.sender_name || apiMessage.sender || 'Unknown',
    senderNumber: apiMessage.author_number,
    content: content,
    displayed_content,
    timestamp: formatMessageTime(apiMessage.sent_at || apiMessage.timestamp || apiMessage.created_at),
    rawTimestamp: apiMessage.sent_at || apiMessage.timestamp || apiMessage.created_at,
    isOwn: apiMessage.origin === "platform",
    isPlatform: apiMessage.origin === "platform",
    isHubspot: apiMessage.origin === "hubspot",
    isEmailResponse: apiMessage.origin === "email",
    isAlert: apiMessage.is_alert || false,
    alertId: apiMessage.alert_id || null,
    wamid: apiMessage.wa_wamid,
    isTemplate: apiMessage.is_template || false,
    parameters: apiMessage.parameters || {},
    attachments: apiMessage.attachments || [],
  };
};

export const transformAlertFromApi = (apiAlert) => {
  const rawTimestamp = apiAlert.createdAt || apiAlert.updatedAt;

  return {
    id: apiAlert._id,
    type: apiAlert.type || 'alert',
    message: apiAlert.summary || apiAlert.message || '',
    timestamp: formatMessageTime(rawTimestamp),
    rawTimestamp,
    groupId: apiAlert.group_id,
    groupName: apiAlert.group_name || '',
    originalMessage: apiAlert.original_message || '',
    senderName: apiAlert.sender_name || '',
  };
};

export const formatMessageTime = (timestamp) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return `${diffDays} days ago`;

  return date.toLocaleDateString('en-GB', {
    month: 'short',
    day: 'numeric',
    year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
  });
};

export const handleApiError = (error) => {
  console.error('API Error:', error);

  if (error.message) {
    return error.message;
  }

  if (error.response) {
    return error.response.data?.message || `HTTP ${error.response.status}`;
  }

  return 'An unexpected error occurred';
};